



















































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import { ModelSync, Prop } from 'vue-property-decorator'
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import dayjs from 'dayjs'
import { DateHelper } from '@/modules/shared/helpers/date'
import isToday from 'dayjs/plugin/isToday'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'

@Component({
  components: {
    BaseInput,
    BaseButton
  }
})
export default class TesDatePicker extends Vue {
  constructor(
    private readonly dateHelper: DateHelper
  ) {
    super()
  }

  @ModelSync('value', 'input') dateAtSync: string

  @Prop({ default: '' }) label: string
  @Prop({ default: false }) disable: boolean
  @Prop({ default: false }) disableThursday: boolean
  @Prop({ default: false }) enableFriday: boolean
  @Prop({ default: false }) enablePast: boolean
  @Prop({ default: false }) noInlineLabel: boolean
  @Prop({ default: true }) showTimeText: boolean
  @Prop({ default: false }) enableTime: boolean
  @Prop({ default: 'مشخص نشده' }) noDateText: string
  @Prop() helpText: string
  @Prop({ default: false }) readonly: boolean

  $refs!: {
    dateAtRef: QPopupProxy
  }

  get dateAt() {
    const date = this.dateHelper.fromJalali(this.dateAtSync).toTimestamp()
    return date !== 'Invalid Date'
      ? ((this.enableTime)
        ? dayjs(this.dateAtSync).format(`YYYY/MM/DD HH:mm`)
        : dayjs(this.dateAtSync).format('YYYY/MM/DD'))
      : ''
  }

  set dateAt(value) {
    const date = this.dateHelper.fromJalali(value).toTimestamp()
    this.dateAtSync = date !== 'Invalid Date' ? date : null
  }

  get valueText() {
    return this.dateAt
      ? (this.enableTime && this.showTimeText)
        ? dayjs(this.dateAtSync).format('dddd YYYY/MM/DD - ساعت HH:mm')
        : dayjs(this.dateAtSync).format('dddd YYYY/MM/DD')
      : this.noDateText
  }

  dateFilter(date) {
    dayjs.extend(isToday)

    const $date = this.dateHelper.fromJalali(date).$d.hour(14).minute(30)

    if ($date.isBefore(dayjs()) && !$date.isToday()) return this.enablePast

    switch ($date.day()) {
      case 5:
        return this.enableFriday
      case 4:
        return !this.disableThursday
      default:
        return true
    }
  }

  clear() {
    this.dateAtSync = null
  }
}
